import { createUseRemoteComponent } from "@paciolan/remote-component/dist/hooks/useRemoteComponent";
import { createRequires } from "@paciolan/remote-component/dist/createRequires";

const requires = createRequires(() => {
  return {
    "@divtel/widget-tools": require("@divtel/widget-tools"),
    'qs': require("qs"),
    'axios': require("axios"),
    'immutable': require("immutable"),
    'moment': require("moment"),
    'numeral': require("numeral"),
    'react': require("react"),
    'react-bootstrap': require("react-bootstrap"),
    'react-calendar': require("react-calendar"),
    'react-dom': require("react-dom"),
    'react-fontawesome': require("react-fontawesome"),
    'react-loading': require("react-loading"),
    'react-router': require("react-router"),
    'react-router-dom': require("react-router-dom"),
    'react-select': require('react-select'),
    'react-ultimate-pagination': require("react-ultimate-pagination"),
    'superagent': require("superagent"),
    'universal-cookie': require("universal-cookie"),
  }
});

export const useRemoteComponent = createUseRemoteComponent({ requires });